import { PersonalityReportResource } from 'affiny-core/modules/api/core/resources/personalityReport.resource';
import { call } from 'redux-saga/effects';

export function* personalityReportValuesSaga(accountId: string) {
  const data = yield call(PersonalityReportResource.getValues, accountId);

  return data;
}

export function* personalityReportVisionSaga(accountId: string) {
  const data = yield call(PersonalityReportResource.getVision, accountId);

  return data;
}

export function* personalityReportPersonalitySaga(accountId: string) {
  const data = yield call(PersonalityReportResource.getPersonality, accountId);

  return data;
}
